<div class="sales-trend-cell" [ngClass]="{ 'sales-trend-cellOrder': params?.isOrder }">
  <div class="sales-trend-value">
    {{(params.defaultColumns == "QtySold" ||params.defaultColumns == "Returns" || params.isQtySold) ? ((params?.value || 0)  | number) : ((params?.value || 0)  | currency)}}
  </div>
</div>
<div class="sales-trend-diffrence" [ngClass]="{ 'success': trend === 'up','accent': trend === 'down'}">{{ (params?.difference || 0) | number: "1.0-2" }}%
  <i class="fas fa-arrow-up" *ngIf="trend === 'up'"></i> 
  <i class="fas fa-arrow-down" *ngIf="trend === 'down'"></i>
</div>